<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      :product-options="productOptions"
      :selected-product="'cso'"
      :filter-names="filterNames"
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <template v-slot:show_on_mobile="{ item }">
        <div>
          {{ item.show_on_mobile ? "Yes" : "No" }}
        </div>
      </template>
      <template v-slot:show_on_portal="{ item }">
        <div>
          {{ item.show_on_portal ? "Yes" : "No" }}
        </div>
      </template>
      <template v-slot:bookable="{ item }">
        <div>
          {{ item.bookable ? "Yes" : "No" }}
        </div>
      </template>

      <template v-slot:actions="{ item }">
        <v-icon
          v-if="isView"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-eye
        </v-icon>
        <v-icon
          v-if="isEdit"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="isDelete"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>

      <!-- add Filters -->
      <!-- <template #addFilters>
        <v-card v-if="authUser.isAdmin">

        </v-card>
      </template> -->
      <!-- add Filters -->
      <template #moreFilters>
        <div>
          <refresh-button
            :is-loading="isLoading"
            @reload="fetchData"
          />
        </div>
      </template>
      <!-- Action Modals -->
      <template #actionModals>
        <div>
          <create-tenant-chargers-assignment
            v-if="isCreate"
            :filter-options="options"
          />

          <edit-tenant-chargers-assignment
            v-if="(isEdit || isView) && editModal"
            :is-visible-dialog="editModal"
            :toggle-edit="toggleEditModal"
            :item="selectedRow"
          />
          <confirmation-modal
            v-if="isDelete"
            :is-visible="deleteModal"
            :toggle="toggleDeleteModal"
            :row="selectedRow"
          />
        </div>
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    CreateTenantChargersAssignment: () =>
      import("./dialogs/CreateTenantChargersAssignment.vue"),
    EditTenantChargersAssignment: () =>
      import("./dialogs/EditTenantChargersAssignment.vue"),
    ConfirmationModal: () =>
      import("@/components/Modals/ConfirmationModal.vue"),
    refreshButton: () => import("@/components/base/RefreshButton.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      productOptions: [
        // { id: "oem", value: "OEM" },
        { id: "cso", value: "CSO" },
      ],
      permissions: {
        view: "",
        create: "tenant-chargers-assignment.list",
        edit: "tenant-chargers-assignment.list",
        delete: "tenant-chargers-assignment.list",
      },
      filters: {},
      subFilters: {},
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "tenantChargersAssignment/getLoading",
      meta: "tenantChargersAssignment/getMeta",
      list: "tenantChargersAssignment/getList",
      //
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("charge_point_id"),
          align: "left",
          sortable: false,
          value: "charge_point_id",
        },
        {
          text: this.$t("parent_tenant_name"),
          align: "left",
          sortable: false,
          value: "owner_tenant_name",
        },
        {
          text: this.$t("location"),
          align: "left",
          sortable: false,
          value: "location_name",
        },
        {
          text: this.$t("assigned_to"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          // showAdmin: true,
        },
        {
          text: "Show on Mobile",
          align: "left",
          sortable: false,
          value: "show_on_mobile",
        },
        {
          text: "Show on Portal",
          align: "left",
          sortable: false,
          value: "show_on_portal",
        },
        {
          text: "Bookable",
          align: "left",
          sortable: false,
          value: "bookable",
        },

        ...(this.isView || this.isEdit || this.isDelete
          ? [
              {
                text: this.$t("actions"),
                align: "left",
                sortable: false,
                value: "actions",
              },
            ]
          : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return ["search"];
    },
  },
  watch: {
    options() {
      this.fetchData();
    },
  },
  mounted() {},
  beforeDestroy() {
    const params = {
      name: "tenant_chargers_assignment",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  methods: {
    async fetchData() {
      const params = { ...this.options };

      await this.$store
        .dispatch("tenantChargersAssignment/list", params)
        .then(() => {
          if (this.options.page > (this.meta?.lastPage || 1)) {
            this.options.page = 1;
          }
        });
    },

    // Confirmation of Delete Row
    async deleteSelectedRow(row) {
      try {
        await this.$store.dispatch("tenantChargersAssignment/destroy", row);
        this.$store.dispatch("alerts/success", this.$t("deleted_successfully"));
        if (this.list.length === 0 && this.meta.lastPage == this.options.page) {
          this.options.page -= 1; // Move to the previous page
        }
        this.toggleDeleteModal("close");
        this.fetchData();
      } catch (error) {
        this.$store.dispatch("alerts/error", error.response?.data?.message);
      }
    },
  },
};
</script>
<style scoped>
.row-box-wrap {
  display: flex;
  align-items: center;
  margin: 8px 0;
  gap: 10px;
  /* Adds space between items */
}

.text-muted {
  color: #6c757d;
}

.highlighted {
  font-weight: bold;
}

.copy-button {
  margin-left: auto;
  /* Pushes the button to the far right */
}
</style>
